"use strict";

var _toConsumableArray = require("/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.web3Enable = web3Enable;
exports.web3Accounts = web3Accounts;
exports.web3AccountsSubscribe = web3AccountsSubscribe;
exports.web3FromSource = web3FromSource;
exports.web3FromAddress = web3FromAddress;
exports.web3ListRpcProviders = web3ListRpcProviders;
exports.web3UseRpcProvider = web3UseRpcProvider;
exports.web3EnablePromise = exports.isWeb3Injected = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _util = require("@polkadot/util");

var _utilCrypto = require("@polkadot/util-crypto");

var _util2 = require("./util");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
} // just a helper (otherwise we cast all-over, so shorter and more readable)


var win = window; // don't clobber the existing object, but ensure non-undefined

win.injectedWeb3 = win.injectedWeb3 || {}; // true when anything has been injected and is available

function web3IsInjected() {
  return Object.keys(win.injectedWeb3).length !== 0;
} // helper to throw a consistent error when not enabled


function throwError(method) {
  throw new Error("".concat(method, ": web3Enable(originName) needs to be called before ").concat(method));
} // internal helper to map from Array<InjectedAccount> -> Array<InjectedAccountWithMeta>


function mapAccounts(source, list, ss58Format) {
  return list.map(function (_ref) {
    var address = _ref.address,
        genesisHash = _ref.genesisHash,
        name = _ref.name;
    var encodedAddress = (0, _utilCrypto.encodeAddress)((0, _utilCrypto.decodeAddress)(address), ss58Format);
    return {
      address: encodedAddress,
      meta: {
        genesisHash: genesisHash,
        name: name,
        source: source
      }
    };
  });
} // have we found a properly constructed window.injectedWeb3


var isWeb3Injected = web3IsInjected(); // we keep the last promise created around (for queries)

exports.isWeb3Injected = isWeb3Injected;
var web3EnablePromise = null;
exports.web3EnablePromise = web3EnablePromise;

function getWindowExtensions(originName) {
  return Promise.all(Object.entries(win.injectedWeb3).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        name = _ref3[0],
        _ref3$ = _ref3[1],
        enable = _ref3$.enable,
        version = _ref3$.version;

    return Promise.all([Promise.resolve({
      name: name,
      version: version
    }), enable(originName).catch(function (error) {
      console.error("Error initializing ".concat(name, ": ").concat(error.message));
    })]);
  }));
} // enables all the providers found on the injected window interface


function web3Enable(originName) {
  if (!originName) {
    throw new Error('You must pass a name for your app to the web3Enable function');
  }

  exports.web3EnablePromise = web3EnablePromise = (0, _util2.documentReadyPromise)(function () {
    return getWindowExtensions(originName).then(function (values) {
      return values.filter(function (value) {
        return !!value[1];
      }).map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            info = _ref5[0],
            ext = _ref5[1];

        // if we don't have an accounts subscriber, add a single-shot version
        if (!ext.accounts.subscribe) {
          ext.accounts.subscribe = function (cb) {
            ext.accounts.get().then(cb).catch(console.error);
            return function () {// no ubsubscribe needed, this is a single-shot
            };
          };
        }

        return _objectSpread(_objectSpread({}, info), ext);
      });
    }).catch(function () {
      return [];
    }).then(function (values) {
      var names = values.map(function (_ref6) {
        var name = _ref6.name,
            version = _ref6.version;
        return "".concat(name, "/").concat(version);
      });
      exports.isWeb3Injected = isWeb3Injected = web3IsInjected();
      console.log("web3Enable: Enabled ".concat(values.length, " extension").concat(values.length !== 1 ? 's' : '', ": ").concat(names.join(', ')));
      return values;
    });
  });
  return web3EnablePromise;
} // retrieve all the accounts accross all providers


function web3Accounts() {
  return _web3Accounts.apply(this, arguments);
}

function _web3Accounts() {
  _web3Accounts = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var _ref7,
        ss58Format,
        accounts,
        injected,
        retrieved,
        addresses,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _ref7 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, ss58Format = _ref7.ss58Format;

            if (web3EnablePromise) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", throwError('web3Accounts'));

          case 3:
            accounts = [];
            _context2.next = 6;
            return web3EnablePromise;

          case 6:
            injected = _context2.sent;
            _context2.next = 9;
            return Promise.all(injected.map(
            /*#__PURE__*/
            function () {
              var _ref9 = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee(_ref8) {
                var accounts, source, list;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        accounts = _ref8.accounts, source = _ref8.name;
                        _context.prev = 1;
                        _context.next = 4;
                        return accounts.get();

                      case 4:
                        list = _context.sent;
                        return _context.abrupt("return", mapAccounts(source, list, ss58Format));

                      case 8:
                        _context.prev = 8;
                        _context.t0 = _context["catch"](1);
                        return _context.abrupt("return", []);

                      case 11:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[1, 8]]);
              }));

              return function (_x7) {
                return _ref9.apply(this, arguments);
              };
            }()));

          case 9:
            retrieved = _context2.sent;
            retrieved.forEach(function (result) {
              accounts.push.apply(accounts, _toConsumableArray(result));
            });
            addresses = accounts.map(function (_ref10) {
              var address = _ref10.address;
              return address;
            });
            console.log("web3Accounts: Found ".concat(accounts.length, " address").concat(accounts.length !== 1 ? 'es' : '', ": ").concat(addresses.join(', ')));
            return _context2.abrupt("return", accounts);

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _web3Accounts.apply(this, arguments);
}

function web3AccountsSubscribe(_x) {
  return _web3AccountsSubscribe.apply(this, arguments);
} // find a specific provider based on the name


function _web3AccountsSubscribe() {
  _web3AccountsSubscribe = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(cb) {
    var _ref11,
        ss58Format,
        accounts,
        triggerUpdate,
        unsubs,
        _args3 = arguments;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _ref11 = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {}, ss58Format = _ref11.ss58Format;

            if (web3EnablePromise) {
              _context3.next = 3;
              break;
            }

            return _context3.abrupt("return", throwError('web3AccountsSubscribe'));

          case 3:
            accounts = {};

            triggerUpdate = function triggerUpdate() {
              return cb(Object.entries(accounts).reduce(function (result, _ref12) {
                var _ref13 = _slicedToArray(_ref12, 2),
                    source = _ref13[0],
                    list = _ref13[1];

                result.push.apply(result, _toConsumableArray(mapAccounts(source, list, ss58Format)));
                return result;
              }, []));
            };

            _context3.next = 7;
            return web3EnablePromise;

          case 7:
            _context3.t0 = function (_ref14) {
              var subscribe = _ref14.accounts.subscribe,
                  source = _ref14.name;
              return subscribe(function (result) {
                accounts[source] = result; // eslint-disable-next-line @typescript-eslint/no-floating-promises

                triggerUpdate();
              });
            };

            unsubs = _context3.sent.map(_context3.t0);
            return _context3.abrupt("return", function () {
              unsubs.forEach(function (unsub) {
                unsub();
              });
            });

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _web3AccountsSubscribe.apply(this, arguments);
}

function web3FromSource(_x2) {
  return _web3FromSource.apply(this, arguments);
} // find a specific provider based on an address


function _web3FromSource() {
  _web3FromSource = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(source) {
    var sources, found;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (web3EnablePromise) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return", throwError('web3FromSource'));

          case 2:
            _context4.next = 4;
            return web3EnablePromise;

          case 4:
            sources = _context4.sent;
            found = source && sources.find(function (_ref15) {
              var name = _ref15.name;
              return name === source;
            });

            if (found) {
              _context4.next = 8;
              break;
            }

            throw new Error("web3FromSource: Unable to find an injected ".concat(source));

          case 8:
            return _context4.abrupt("return", found);

          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _web3FromSource.apply(this, arguments);
}

function web3FromAddress(_x3) {
  return _web3FromAddress.apply(this, arguments);
} // retrieve all providers exposed by one source


function _web3FromAddress() {
  _web3FromAddress = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(address) {
    var accounts, found, accountU8a;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (web3EnablePromise) {
              _context5.next = 2;
              break;
            }

            return _context5.abrupt("return", throwError('web3FromAddress'));

          case 2:
            _context5.next = 4;
            return web3Accounts();

          case 4:
            accounts = _context5.sent;

            if (address) {
              accountU8a = (0, _utilCrypto.decodeAddress)(address);
              found = accounts.find(function (account) {
                return (0, _util.u8aEq)((0, _utilCrypto.decodeAddress)(account.address), accountU8a);
              });
            }

            if (found) {
              _context5.next = 8;
              break;
            }

            throw new Error("web3FromAddress: Unable to find injected ".concat(address));

          case 8:
            return _context5.abrupt("return", web3FromSource(found.meta.source));

          case 9:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _web3FromAddress.apply(this, arguments);
}

function web3ListRpcProviders(_x4) {
  return _web3ListRpcProviders.apply(this, arguments);
} // retrieve all providers exposed by one source


function _web3ListRpcProviders() {
  _web3ListRpcProviders = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6(source) {
    var _ref16, provider;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return web3FromSource(source);

          case 2:
            _ref16 = _context6.sent;
            provider = _ref16.provider;

            if (provider) {
              _context6.next = 7;
              break;
            }

            console.warn("Extension ".concat(source, " does not expose any provider"));
            return _context6.abrupt("return", null);

          case 7:
            return _context6.abrupt("return", provider.listProviders());

          case 8:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _web3ListRpcProviders.apply(this, arguments);
}

function web3UseRpcProvider(_x5, _x6) {
  return _web3UseRpcProvider.apply(this, arguments);
}

function _web3UseRpcProvider() {
  _web3UseRpcProvider = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee7(source, key) {
    var _ref17, provider, meta;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return web3FromSource(source);

          case 2:
            _ref17 = _context7.sent;
            provider = _ref17.provider;

            if (provider) {
              _context7.next = 6;
              break;
            }

            throw new Error("Extension ".concat(source, " does not expose any provider"));

          case 6:
            _context7.next = 8;
            return provider.startProvider(key);

          case 8:
            meta = _context7.sent;
            return _context7.abrupt("return", {
              meta: meta,
              provider: provider
            });

          case 10:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _web3UseRpcProvider.apply(this, arguments);
}